import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { getShopInfo, getPwInfo } from '@/api/index'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', name: 'Login', component: () => import('@/views/login.vue') },
  { 
    path: '/place-order', 
    name: 'PlaceOrder', 
    component: () => import('@/views/order/index.vue'),
    meta: { requiresAuth: true }
  },
  { 
    path: '/order-query', 
    name: 'OrderQuery', 
    component: () => import('@/views/record/index.vue'),
    meta: { requiresAuth: true }
  },
  { 
    path: '/edit-profile', 
    name: 'EditProfile', 
    component: () => import('@/views/profile/index.vue'),
    meta: { requiresAuth: true }
  },
  { 
    path: '/edit-password', 
    name: 'EditPassword', 
    component: () => import('@/views/passwordEdit/index.vue'),
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

let isFetchingUserInfo = false

router.beforeEach(async (to, from, next) => {
  if (!store.state.shop.loaded) {
    await getShopInfo().then(res => {
      const shop = res.data
      store.commit('shop/SET_SHOP', shop)
      document.title = shop.name
    }).catch(() => {

    })
  }
  if (to.path === '/login') {
    next()
    return
  }
  const isAuthenticated = store.getters['user/isAuthenticated']
  if (!isAuthenticated) {
    next('/login')
    return
  }
  const userInfo = store.getters['user/userInfo']
  if (userInfo) {
    next()
    return
  }
  if (isFetchingUserInfo) {
    const checkInterval = setInterval(() => {
      if (!isFetchingUserInfo) {
        clearInterval(checkInterval)
        next({ ...to, replace: true })
      }
    }, 100)
    return
  }
  isFetchingUserInfo = true

  await getPwInfo(store.getters['user/token']).then(res => {
    store.commit('user/SET_USER_INFO', res.data)
    next()
  }).catch(() => {
    store.dispatch('user/logout')
    next('/login')
  }).finally(() => {
    isFetchingUserInfo = false
  })
})

export default router